export default __webpack_public_path__ + "static/media/Asset.5844bc9b.png";